<div class="container">
  <app-functional-capabilities-table-section
    [ocnTable]="true"
    class="OrderChangeNotifAuthTable"
    [tableSections]="functionalCapabilitiesOCNAuthentication.tableSections"
  ></app-functional-capabilities-table-section>
</div>
